<template>
  <b-container fluid>
    <b-row class="py-2">
      <b-col cols="auto">
        <b-button
          squared
          size="sm"
          class="px-5"
          :disabled="itemsInput.length <= 0"
          @click="selectAllHandler"
        >เลือกทั้งหมด</b-button>
      </b-col>
      <b-col cols="auto">
        <b-button
          size="sm"
          squared
          class="px-5"
          :disabled="itemsInput.length <= 0"
          @click="notSelectAllHandler"
        >ไม่เลือกทั้งหมด</b-button>
      </b-col>
      <!-- <template v-if="!isEdit"> -->
      <b-col cols="auto">
        <datepicker
          v-model="filterLabDateComputed"
          :minimum-view="'month'"
          :disabled="isEdit"
          :clear-button="!isEdit"
          format="MMM yyyy"
          input-class="date-box"
          @input="filters()"
          @cleared="filters()"
        />
      </b-col>
      <!-- </template> -->
    </b-row>
    <b-row>
      <b-col>
        <b-table
          :fields="fields"
          :items="itemsInput"
          :is-busy="isBusy"
          sticky-header
          responsive
          selectable
          show-empty
          empty-text="ไม่มีผลลัพธ์"
          class="lab-invoice-table"
          select-mode="single"
          @row-selected="selectLabInvoice"
        >
          <template slot="select" slot-scope="data">
            <b-form-checkbox
              :ref="`lab-check-${data.index}`"
              v-model="labInvoicesChecksInput"
              :value="data.item.ln"
            />
          </template>
          <template slot="labAmount" slot-scope="data">
            {{
            $numeral(data.item.labAmount).format("0,0")
            }}
          </template>
          <template slot="totalPrice" slot-scope="data">
            {{
            $numeral(data.item.totalPrice).format("0,0[.]00")
            }}
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row
      align-h="end"
      style="background: #808080; padding: 1rem; margin: 1px; color: #FFF; font-weight: bold;"
    >
      <b-col>
        <b-row align-h="end">
          <b-col cols="auto">รวม</b-col>
          <b-col cols="auto">{{ $numeral(orderPrice.toFixed(2)).format("0,0[.]00") }} บาท</b-col>
        </b-row>
        <template v-if="promotions.length > 0">
          <template v-for="(promotion, index) in promotions">
            <b-row :key="`promotion-label-${index}`" align-h="end">
              <b-col class="my-auto" cols="auto">โปรโมชั่น {{ promotion.name }}</b-col>
              <b-col class="my-auto" cols="auto">
                {{
                $numeral(getPromotionDiscount(promotion)).format("0,0[.]00")
                }}
                บาท
              </b-col>
            </b-row>
          </template>
        </template>
        <template v-if="toInputCheck">
          <b-row align-h="end">
            <b-col cols="auto">ค่าขนส่ง</b-col>
            <b-col cols="auto">
              {{
              $numeral((+toInput).toFixed(2)).format("0,0[.]00")
              }}
              บาท
            </b-col>
          </b-row>
        </template>
        <template v-if="withHoldingTax">
          <b-row align-h="end">
            <b-col cols="auto">ภาษี ณ ที่จ่าย 3%</b-col>
            <b-col cols="auto">
              {{
              $numeral(allPrice | holdingTax).format("0,0[.]00")
              }}
              บาท
            </b-col>
          </b-row>
        </template>
        <b-row align-h="end">
          <b-col cols="auto">รวมทั้งสิ้น</b-col>
          <b-col cols="auto">{{ $numeral(netPrice).format("0,0[.]00") }} บาท</b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  name: "LabInvoiceTable",
  components: {
    Datepicker,
  },
  filters: {
    holdingTax(value) {
      return (value * 0.03).toFixed(2);
    },
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    labInvoicesChecks: {
      type: Array,
      default: () => [],
    },
    selectLabInvoice: {
      type: Function,
    },
    toInputCheck: {
      type: Boolean,
      default: false,
    },
    withHoldingTax: {
      type: Boolean,
      default: false,
    },
    toInput: {
      type: Number || String,
      default: 0,
    },
    orderPrice: {
      type: Number,
      default: 0,
    },
    promotions: {
      type: Array,
      default: () => [],
    },
    filterLabDate: {
      type: Date,
      default: new Date(),
    },
    filters: {
      type: Function,
      default: () => false,
    },
  },
  data() {
    return {
      fields: [
        { key: "select", label: "เลือก" },
        { key: "ln", label: "LN" },
        { key: "animalName", label: "ชื่อสัตว์" },
        { key: "labAmount", label: "จำนวนตรวจ" },
        { key: "totalPrice", label: "ราคารวม" },
        { key: "orderDate", label: "วันที่สั่งตรวจ" },
        { key: "approveUser", label: "ผู้อนุมัติ" },
      ],
    };
  },
  computed: {
    allPrice() {
      let allPrice = this.orderPrice;
      let discountPrice = 0;

      this.promotions.forEach((promotion) => {
        discountPrice += this.getPromotionDiscount(promotion);
      });

      allPrice -= discountPrice;

      allPrice = allPrice < 0 ? 0 : allPrice;

      if (this.toInputCheck) {
        allPrice += +this.toInput;
      }

      return allPrice;
    },
    filterLabDateComputed: {
      get() {
        return this.filterLabDate;
      },
      set(value) {
        return this.$emit("update:filterLabDate", value);
      },
    },
    netPrice() {
      let netPrice = this.allPrice;

      const holdingTax = +(this.allPrice * 0.03).toFixed(2);
      if (this.withHoldingTax) {
        netPrice -= holdingTax;
      }
      return netPrice.toFixed(2);
    },
    itemsInput: {
      get() {
        return this.items;
      },
      set(value) {
        this.$emit("update:items", value);
      },
    },
    labInvoicesChecksInput: {
      get() {
        return this.labInvoicesChecks;
      },
      set(value) {
        this.$emit("update:labInvoicesChecks", value);
      },
    },
    labsDataCheck() {
      return this.items.filter((labInvoice, index) =>
        this.labInvoicesChecks.includes(labInvoice.ln)
      );
    },
  },
  methods: {
    updateCheckLabInvoice(index) {
      if (this.labInvoicesChecksInput.includes(index)) {
        this.labInvoicesChecksInput = this.labInvoicesChecksInput.filter(
          (check) => check !== index
        );
      } else {
        this.labInvoicesChecksInput.push(index);
      }
    },
    notSelectAllHandler() {
      this.labInvoicesChecksInput = [];
    },
    selectAllHandler() {
      // const indexAll = Object.keys(this.itemsInput).map((index) => +index);
      const indexAll = this.itemsInput.map((index) => index.ln);
      this.labInvoicesChecksInput = indexAll;
      // console.log(this.itemsInput, ".labthis.itemsInputnvoicesChecksInput");
      // console.log(indexAll, ".labthis.index");
      this.$forceUpdate();
    },
    getPromotionDiscount(promotion) {
      const type = promotion.type;
      const discountType = promotion.discount_type;
      let value = promotion.value;
      let discount = 0;

      if (type === "all") {
        if (discountType === "percent") {
          discount += +this.orderPrice.toFixed(2) * (value / 100);
        } else if (discountType === "baht") {
          discount +=
            +this.orderPrice.toFixed(2) < value
              ? +this.orderPrice.toFixed(2)
              : value;
        }
      } else if (type === "each") {
        if (promotion.set_test_id) {
          this.itemsInput.forEach((item) => {
            let productDiscount = item.labInvoices.find(
              (labInvoice) => labInvoice.set_test_id === promotion.set_test_id
            );
            if (productDiscount) {
              if (discountType === "percent") {
                discount += +(
                  productDiscount.price.toFixed(2) * (+value / 100).toFixed(2)
                ).toFixed(2);
              } else if (discountType === "baht") {
                discount += +value;
              }
            }
          });
        } else if (promotion.test_id) {
          this.labsDataCheck.forEach((item) => {
            let productDiscount = item.labInvoices.find(
              (labInvoice) => labInvoice.test_id === promotion.test_id
            );
            if (productDiscount) {
              if (discountType === "percent") {
                discount += +(
                  productDiscount.price.toFixed(2) * (+value / 100).toFixed(2)
                ).toFixed(2);
              } else if (discountType === "baht") {
                discount += +value;
              }
            }
          });
        }
      }

      return +discount.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.lab-invoice-table {
  height: 35rem;
  /*width: 45rem;*/
  width: 100%;
  border: 1px solid #6b757f;
}
</style>

<style>
.date-box {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: center;
}
</style>
